import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FrameComponent } from '../../FrameComponent';
import FrameSection from './FrameSection';
import '../scss/HeaderFooterBase.scss';

const allowedChildren = {
    FrameSection,
};

function getChildWithType(children, type, variant) {
    const childrenWithType = [];
    React.Children.forEach(children, (child) => {
        if (child && (type === child.props.position)) {
            childrenWithType.push(React.cloneElement(child, { variant }));
        }
    });
    if (childrenWithType.length === 1) {
        return childrenWithType[0];
    }
    if (childrenWithType.length >= 1) {
        throw new Error(variant, ' has duplicate children');
    } else {
        return null;
    }
}

const HeaderFooterBase = ({
    children,
    className,
    variant,
    ...otherProps
}) => (
    <FrameComponent
        className={classNames(className)}
        {...otherProps}
        leftElement={getChildWithType(children, 'left', variant)}
        middleElement={getChildWithType(children, 'middle', variant)}
        rightElement={getChildWithType(children, 'right', variant)}
        orientation="horizontal" />
);

HeaderFooterBase.propTypes = {
    children(props, propName, componentName) {
        let error;
        const prop = props[propName];
        React.Children.forEach(prop, (child) => {
            if (!(Object.values(allowedChildren)).includes(child.type)) {
                error = new Error(
                    `\`${componentName}\` only accepts childrens of type \`${Object.keys(allowedChildren)}\`.`
                );
            }
        });

        return error;
    },

    variant: PropTypes.oneOf(['Header', 'Footer']).isRequired,
};

HeaderFooterBase.defaultProps = {
    children: null,
};

export default HeaderFooterBase;
